import { STAGE_ORDER, stageIndex, type EventStatus } from '@lib/care-model';

/**
 * The 5-dot workflow progress glyph (new -> in progress -> actioned -> in review -> cleared), filled
 * teal up to the row's current stage. Shared by QueueTable (per event) and ThreadTable (the thread's
 * rollup stage), so the two tables cannot drift.
 */
export function StageDots({ status }: { status: EventStatus }) {
  const idx = stageIndex(status);
  return (
    <span style={{ display: 'inline-flex', gap: 3 }} aria-label={`stage ${idx + 1} of ${STAGE_ORDER.length}`}>
      {STAGE_ORDER.map((_, i) => (
        <span
          key={i}
          style={{
            width: 6,
            height: 6,
            borderRadius: 999,
            background: i <= idx ? 'var(--teal-2)' : 'var(--rule)',
          }}
        />
      ))}
    </span>
  );
}
